export const documents_workflow_for_table = [
  {
    value: 'undefined',
    label: 'не указан',
  },
  {
    value: 'sbis',
    label: 'СБИС',
  },
  {
    value: 'diadoc',
    label: 'Диадок',
  },
  {
    value: 'nopaper',
    label: 'Nopaper',
  },
  {
    value: 'paper',
    label: 'Бумажный',
  },
]
export const documents_workflow = [
  {
    value: 'undefined',
    label: 'выберите тип документооборота',
  },
  {
    value: 'sbis',
    label: 'СБИС',
  },
  {
    value: 'diadoc',
    label: 'Диадок',
  },
  {
    value: 'nopaper',
    label: 'Nopaper',
  },
  {
    value: 'paper',
    label: 'Бумажный',
  },
]
